<template>
    <div class="full-page">
        <div class="window loading-screen" v-if="!callReturned">
            <span class="top-text loading-text">Plan Loading....</span>
            <div class="lds-dual-ring"></div>
        </div>
        <div class="window" v-else-if="gotLoad404">
            <span class="title" style="font-size: 2em; margin-bottom: 1em;">Plan not found</span>
            <span class="subtitle" style="text-align: center">Couldn't find a plan with code {{ planKey }} in database. If you're sure that code is correct, Carter can help get everything sorted out!</span>
        </div>
        <div class="window" v-else-if="gotLoad500">
            <span class="title" style="font-size: 2em; margin-bottom: 1em;">Server Error</span>
            <span class="subtitle" style="text-align: center;">The server encountered an error trying to retrieve that plan. Try refreshing the page- if that doesn't work, please tell Carter about the error & include the plan code in your message! <a href="mailto:carter@dentalmenu.com" style="color:var(--color-bright-blue)">carter@dentalmenu.com</a></span>
         </div>
        <div class="window" v-else>
            <span class="top-text">Submit Plan</span>
            <span class="subtitle">for {{ practiceName }}</span>
            <div class="two-column-row">
                <span class="attribute-name">Monthly Fee:</span>
                <span style="margin-top: 1px; margin-right: 5px; font-size: 1.2em; color: var(--color-dark-blue)">$</span><input type="text" v-model="monthlyFeeString" class="standard-text-input hover-grow" @input="ValidateMonthlyFee()">
            </div>
            <div class="two-column-row">
                <span class="attribute-name">Velox ID:</span>
                <input type="text" v-model="extraData.veloxID" class="standard-text-input hover-grow" @input="ValidateVeloxID()">
            </div>
            <div class="two-column-row">
                <span class="attribute-name">PMS Insurance ID:</span>
                <input type="text" v-model="extraData.pmsInsuranceID" class="standard-text-input hover-grow" @input="ValidatePMS()">
            </div>
            <div class="two-column-row">
                <span class="attribute-name">Payout Method:</span>
                <select v-model="extraData.payoutMethod" class="standard-text-input hover-grow" style="cursor: pointer">
                    <option disabled value="">Select Payout Method</option>
                    <option :value="'stripe_default'">Automated Daily Payouts</option>
                    <option :value="'manual_claims'">Manual Payouts</option>
                </select>
            </div>
            <div class="two-column-row">
                <span class="attribute-name">Enable Claims?</span>
                <div class="checkbox-container input-class no-hover-border">
                    <div class="checkbox grow-medium" @click="ToggleClaims()">
                        <div class="checkbox-fill" v-if="extraData.enableClaims">
                            <p class="checkbox-text no-select">✓</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="two-column-row">
                <span class="attribute-name">Enable Cash Payments?</span>
                <div class="checkbox-container input-class no-hover-border">
                    <div class="checkbox grow-medium" @click="ToggleCash()">
                        <div class="checkbox-fill" v-if="extraData.enableCash">
                            <p class="checkbox-text no-select">✓</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="two-column-row">
                <span class="attribute-name">Benefits available now?</span>
                <div class="checkbox-container input-class no-hover-border">
                    <div class="checkbox grow-medium" @click="ToggleReadyNow()">
                        <div class="checkbox-fill" v-if="extraData.readyNow">
                            <p class="checkbox-text no-select">✓</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="two-column-row">
                <span class="attribute-name">Is Pediatric Practice?</span>
                <div class="checkbox-container input-class no-hover-border">
                    <div class="checkbox grow-medium" @click="TogglePediatric()">
                        <div class="checkbox-fill" v-if="extraData.isPediatric">
                            <p class="checkbox-text no-select">✓</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="two-column-row">
                <span class="attribute-name">Supress Rewards?</span>
                <div class="checkbox-container input-class no-hover-border">
                    <div class="checkbox grow-medium" @click="ToggleSuppressRewards()">
                        <div class="checkbox-fill" v-if="extraData.suppressRewards">
                            <p class="checkbox-text no-select">✓</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="two-column-row">
                <span class="attribute-name">Waive Enrollment Fee for Annual Payments?</span>
                <div class="checkbox-container input-class no-hover-border">
                    <div class="checkbox grow-medium" @click="ToggleWaiveForAnnual()">
                        <div class="checkbox-fill" v-if="extraData.waiveForAnnual">
                            <p class="checkbox-text no-select">✓</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="two-column-row">
                <span class="attribute-name">Enable Patient Portal?</span>
                <div class="checkbox-container input-class no-hover-border">
                    <div class="checkbox grow-medium" @click="TogglePortal()">
                        <div class="checkbox-fill" v-if="extraData.patientPortal">
                            <p class="checkbox-text no-select">✓</p>
                        </div>
                    </div>
                </div>
            </div>
                <button class="submit-btn hover-grow" @click="HandleSubmitClick()" v-if="showSubmitBtn" :disabled="isSubmitting">
                    <div v-if="isSubmitting" class="button-content">
                        <div class="spinner"></div>
                        <span>Submitting...</span>
                    </div>
                    <span v-else>Submit Plan</span>
                </button>
                <div class="submit submit-success" v-if="gotSubmit202">
                    Plan submitted successfully!
                </div>
                <button class="submit-btn hover-grow" @click="CreateLandingPage()" v-if="showCreateBtn" :disabled="isCreatingLanding">
                    <div v-if="isCreatingLanding" class="button-content">
                        <div class="spinner"></div>
                        <span>Creating...</span>
                    </div>
                    <span v-else>Create Landing Page</span>
                </button>
                <div class="submit submit-success" v-if="gotLanding201">
                    Landing Page Created Successfully!
                </div>
                <div class="submit submit-error" v-if="showErrorMessage || noLandingPageSpecified">
                    {{ errorMessage }}
                </div>

        </div>
        <transition name="fade" mode="out-in">
            <div class="modal-overlay" v-if="showWarn" @click.self="RemoveWarn">
                <WarnModal @click.stop @exitModal="RemoveWarn" @YesSubmit="SubmitPlan()">

                </WarnModal>
            </div>
        </transition>
    </div>
</template>

<script>
import { InputToInteger, GetPlanFromDB, UpdatePlanDataInDB, SubmitPlanToDB, CreateLandingPageUtil, CalculateComputedPlanPrice, FormatCurrency } from '../Onboarding/utils/functions';
import { mapActions } from 'vuex';
import WarnModal from './SubmitWarnModal.vue'
let dev = true;
// let url = dev ? "http://127.0.0.1:8000/" : "https://app.dentmenu.com/v2/" // Old URL for local instance
let url = dev ? "http://10.200.200.1/v2/" : "https://app.dentmenu.com/v2/"  // New URL for kolla-test instance
export default {
    components: {
        WarnModal
    },
    props: {
        planKey: String,
    },
    data() {
        return {
            practiceName: "",
            extraData: {
                monthlyFee: 4,
                veloxID: 0,
                pmsInsuranceID: 0,
                payoutMethod: "stripe_default",
                enableClaims: false,
                enableCash: false,
                readyNow: false,
                isPediatric: false,
                suppressRewards: false,
                waiveForAnnual: false,
                patientPortal: false,
            },            
            callReturned: false,
            gotLoad404: false,
            gotLoad500: false,
            gotSubmit404: false,
            gotSubmit500: false,
            gotSubmit202: false,
            gotSubmit400: false,
            gotLanding201: false,
            gotLanding400: false,
            gotLanding404: false,
            gotLanding500: false,
            noLandingPageSpecified: false,
            errorMessage: "",
            monthlyFeeString: "",
            submitBtnText: "Submit Plan",
            landingPageBtnText: "Create Landing Page",
            showSubmitBtn: true,
            showCreateBtn: true,
            localPlan: null,
            planID: 0,
            showWarn: false,
            isSubmitted: false,
            showErrorMessage: false,
            isSubmitting: false,
            isCreatingLanding: false,
        }
    },
    computed: {
        monthlyFeeStore() {
            return 2;
        },
        planLink() {
            return "https://dentalmenuonboarding.com/build/" + this.planKey;
        },
        store() {
            return this.$store.state;
        }
    },
    methods: {
        ...mapActions(['setEverything', 'updatePlan', 'setDMFee']),
        ValidateMonthlyFee() {
            this.monthlyFeeString = this.monthlyFeeString.replace(/[^0-9.]/g, '');
            let num = parseFloat(this.monthlyFeeString);
            this.extraData.monthlyFee = num;
            this.setDMFee(num);
        },
        ValidateVeloxID() {
            this.extraData.veloxID = InputToInteger(this.extraData.veloxID);
        },
        ValidatePMS() {
            this.extraData.pmsInsuranceID = InputToInteger(this.extraData.pmsInsuranceID);
        },
        HandleSubmitClick() {
            if(this.isSubmitted) {
                console.log("1");
                this.DisplayWarn();
                return;
            }
            this.SubmitPlan();
        },
        async SubmitPlan() {
            this.isSubmitting = true;
            this.showErrorMessage = false;
            console.log("Entering SubmitPlan");
            this.gotLoad404 = false;
            this.gotLoad500 = false;
            let response = "";
            if(await this.$store.getters.contactPageFilled() === false) {
                this.errorMessage = "Contact information is missing or incorrect. Please fill in all contact information to submit this plan"
                this.showErrorMessage = true;
                this.isSubmitting = false;
                return;
            }
            if(this.localPlan.dentalMenuFee !== this.extraData.monthlyFee || this.localPlan.isPediatric !== this.extraData.isPediatric) {
                this.localPlan.dentalMenuFee = this.extraData.monthlyFee;
                this.localPlan.isPediatric = this.extraData.isPediatric;
                await UpdatePlanDataInDB(this.planID, this.localPlan);
            }
            try {
                response = await SubmitPlanToDB(this.planKey, this.extraData);
            }
            catch(error) {
                this.isSubmitting = false;
                if(error.response.status === 500) {
                    this.errorMessage = "There was an error while submitting this plan. If this issue persists, get in touch with Carter!"
                    this.showErrorMessage = true;
                    return;
                }
                else if(error.response.status === 404) {
                    this.errorMessage = "Unable to locate a plan with this key to create a page for. If you see this error, get in touch with Carter!"
                    this.showErrorMessage = true;
                    return;
                }
                else if(error.response.status === 400) {
                    this.errorMessage = error.response.data;
                    this.errorMessage = "There's bad data somewhere in this practice's plans. The following message was returned by the server: " + error.response.data
                    this.showErrorMessage = true;
                    return;
                }
            }
            if(response.status === 202) {
                this.gotSubmit202 = true;
            }
            this.showSubmitBtn = false;
            this.isSubmitting = false;
        },
        async CreateLandingPage() {
            this.isCreatingLanding = true;
            this.showErrorMessage = false;
            if(this.localPlan.landingPage === "") {
                this.noLandingPageSpecified = true;
                this.showCreateBtn = false;
                this.showSubmitBtn = false;
                this.isCreatingLanding = false;
                this.errorMessage = "No landing page address specified. Please specify a landing page address to create a landing page for this practice";
                return;
            }
            if(await this.$store.getters.contactPageFilled() === false) {
                this.errorMessage = "Contact information is missing or incorrect. Please fill in all contact information to create a landing page for this practice"
                this.showErrorMessage = true;
                this.isCreatingLanding = false;
                return;
            }
            if(this.localPlan.includeDMFee) {
                let plans = this.localPlan.plans;
                plans.forEach((plan) => {
                    if(plan.monthlyPriceAltered) {
                        return;
                    }
                    plan.price = CalculateComputedPlanPrice(this.$store, plan);
                    if(!plan.monthlyPriceAltered && !plan.annualPriceAltered) {
                        plan.annualPrice = plan.price * 12;
                    }
                    this.updatePlan(plan);
                })
            }
            this.localPlan = this.$store.state;
            this.localPlan.dentalMenuFee = this.extraData.monthlyFee;
            let result = UpdatePlanDataInDB(this.planID, this.localPlan);

            try {
                const response = await CreateLandingPageUtil(this.planKey, this.extraData);
                if(response.status === 201) {
                    this.gotLanding201 = true;
                    this.showCreateBtn = false;
                }
            }
            catch(error) {
                this.isCreatingLanding = false;
                if(error.response?.status === 400) {
                    this.errorMessage = "There was an error with the landing page data. Please check all fields and try again.";
                } else if(error.response?.status === 404) {
                    this.errorMessage = "Unable to locate a plan with this key to create a page for. If you see this error, get in touch with Carter!";
                } else if(error.response?.status === 500) {
                    this.errorMessage = "There was an error while creating the landing page. It's not likely, but a landing page may have been created. If this issue persists, get in touch with Carter!";
                } else {
                    this.errorMessage = "An unexpected error occurred while creating the landing page. Please try again.";
                }
                this.showErrorMessage = true;
            }
            this.showCreateBtn = false;
            this.isCreatingLanding = false;
        },
        ToggleClaims() {
            this.extraData.enableClaims = !this.extraData.enableClaims;
        },
        ToggleCash() {
            this.extraData.enableCash = !this.extraData.enableCash;
        },
        ToggleReadyNow() {
            this.extraData.readyNow = !this.extraData.readyNow;
        },
        TogglePediatric() {
            this.extraData.isPediatric = !this.extraData.isPediatric;
        },
        ToggleSuppressRewards() {
            this.extraData.suppressRewards = !this.extraData.suppressRewards;
        },
        ToggleWaiveForAnnual() {
            this.extraData.waiveForAnnual = !this.extraData.waiveForAnnual;
        },
        TogglePortal() {
            this.extraData.patientPortal = !this.extraData.patientPortal;
        },
        async LoadPlan() {
            let returnData = await GetPlanFromDB(this.planKey);
            if (returnData === 404) {
                this.gotLoad404 = true;
                this.callReturned = true;
                return;
            }
            else if (returnData === 500) {
                this.callReturned = true;
                this.gotLoad500 = true;
                return;
            }
            //console.log("SubmitPlan.LoadPlan.returnData = ", returnData);
            //console.log("returnData = ", returnData);
            this.localPlan = JSON.parse(returnData.plans);
            this.extraData.monthlyFee = this.localPlan.dentalMenuFee;
            this.planID = returnData.id;
            this.setEverything(this.localPlan);
            this.monthlyFeeString = FormatCurrency(this.extraData.monthlyFee);
        
            this.practiceName = this.localPlan.practiceName;
            this.callReturned = true;
            this.isSubmitted = returnData.submitted;
            this.extraData.isPediatric = this.localPlan.isPediatric;
        },
        DisplayWarn() {
            this.showWarn = true;
        },
        RemoveWarn() {
            this.showWarn = false;
        }
    },
    mounted() {
        this.LoadPlan();
    }
}
</script>

<style scoped>
.full-page {
    width: 100vw;
    height: 100vh;
    background-color: var(--color-teal-background);
    display: flex;
    align-items: center;
    justify-content: center;
}

.window {
    background-color: white;
    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    border: 3px solid var(--font-color-teal);
    padding: 2em;
}

.top-text {
    color: var(--font-color-teal);
    font-size: 3em;
}

.subtitle {
    color: var(--color-dark-blue);
    font-size: 1.2em;
    margin-bottom: 1.5em;
}

.two-column-row {
    display: flex;
    flex-direction: row;
    width: 75%;
    justify-content: space-between;
    font-size: 1.2em;
    color: var(--color-dark-blue);
    margin: 0.5em;
}

.attribute-name {
    flex: 1;
}

.standard-text-input {
    font-size: 1.05em;
    flex: 1;
    width: 100%;
}

.submit-btn {
    background-color: transparent;
    outline: none;
    border: 3px solid var(--color-medium-light-gray);
    font-size: 1.5em;
    border-radius: 50px;
    cursor: pointer;
    padding: 0.25em 1em;
    color: var(--color-dark-blue);
    font-weight: 900;
    margin-top: 1em;
    text-align: center;
    min-width: 250px;
}

.submit-btn:disabled {
    border-color: var(--color-medium-light-gray);
    color: var(--color-medium-gray);
    cursor: not-allowed;
}

.submit-btn:disabled:hover {
    transform: none;
    border-color: var(--color-medium-light-gray);
}

.submit-btn:focus {
    outline: none;
}

.submit {
    margin-top: 1em;
    text-align: center;
    font-weight: 900;
}

.submit-error {
    color: var(--color-medium-red);
}

.submit-success {
    color: var(--color-bright-blue);
    font-size: 2em;
}

.checkbox-container {
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.no-hover-border:hover {
    border: none;
}

.checkbox {
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid var(--color-dark-blue);
    border-radius: 5px;
    cursor: pointer;
}

.checkbox-fill {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 23px;
    height: 23px;
    background-color: var(--color-dark-blue);
    border-radius: 3px;
    color: white;
}

.checkbox-text {
    margin: 0;
    font-size: 1.2em;
    left: 2px;
    top: -3px;
}

.submit-btn:hover, .submit-btn:focus {
    border: 3px solid var(--color-dark-blue)
}

.lds-dual-ring {
  display: inline-block;
  width: 40%;
  height: 40%;
  margin-left: 4.5em;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 200px;
  height: 200px;
  margin: 8px;
  border-radius: 50%;
  border: 12px solid transparent;
  border-color: var(--color-dark-blue) transparent var(--color-dark-blue) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.button-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5em;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid transparent;
    border-top-color: var(--color-medium-gray);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>